<a3l-ui-icon icon="search" class="rex-searchbar__icon"></a3l-ui-icon>
<input type="text" [disabled]="disabled" [placeholder]="placeholder" class="rex-searchbar__input" (focus)="focused = true" (blur)="focused = false" />
